export default {
  listFeature: undefined,
  listEmployeeRoleIds: undefined,
  listEmployeeRoles: undefined,
  currentEmployeeRoleCode: undefined,
  currentUser: undefined,
  companyInfo: undefined,
  userProfile: undefined,
  employeeInfo: undefined,
  redirectLogin: undefined,
  countEnterWrongOTP: 0,
  navSub: undefined,
  dashBoard: {
    refreshData: 0
  },
}
